/**
 * Created by admin on 2018/5/18.
 */
import { Base64 } from 'js-base64';
import * as accountService from '../services/account';
import { PATHS, REPORT_ACTIVE_TYPE } from '../utils/constants';

export default {
  namespace: 'role',
  state: {
    allMenus: [], //所有的菜单信息，树形结构
    roleMenus: [], //所有的角色-菜单信息
    roleUsers: [],
    searchUsers: [], //新增用户时根据过滤条件搜索到的用户
    searchUsersPagi: {
      //新增用户时，根据过滤条件搜索到的用户，分页信息
      current: 1,
      pageSize: 7,
      total: 0
    }
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchUsersPagi(state, { payload }) {
      state.searchUsersPagi = { ...{}, ...state.searchUsersPagi, ...payload };
      return { ...state };
    }
  },
  effects: {
    *findAllMenus(_, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { data: allMenus = [], status } = yield call(
        accountService.getAllMenus,
        locale
      );
      if (status === 0 && allMenus) {
        yield put({ type: 'update', payload: { allMenus } });
      }
    },
    *findAllRoles(_, { call, put, select }) {
      const { data: roleMenus = [], status } = yield call(
        accountService.getAllRoles
      );
      if (status === 0 && roleMenus) {
        yield put({ type: 'update', payload: { roleMenus } });
      }
      yield put({ type: 'findAllRoles@@end' });
    },
    *findRoleUsers({ roleId }, { call, put, select }) {
      const { data, status, msg } = yield call(
        accountService.getPageUserByRole,
        { roleId }
      );
      if (status === 0) {
        const { rows: roleUsers = [] } = data;
        yield put({ type: 'update', payload: { roleUsers } });
      } else {
        throw new Error(msg);
      }
    },
    *searchRoleUsers(
      { name, position, resolve, reject },
      { call, put, select }
    ) {
      const { searchUsersPagi } = yield select(state => state.role);
      const { current, pageSize } = searchUsersPagi;
      const { data, status, msg } = yield call(accountService.searchRoleUsers, {
        name,
        position,
        current,
        pageSize
      });
      if (status === 0) {
        const { rows: searchUsers = [], records } = data;
        yield put({ type: 'update', payload: { searchUsers } });
        yield put({
          type: 'updateSearchUsersPagi',
          payload: { total: records }
        });
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    },
    *save(
      { roleId = '', roleKey = '', roleName = '', menus = [], resolve, reject },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const { userId: optId } = yield select(state => state.login.userInfo);
      const menuIds = [];
      menus.every(menu => menuIds.push(menu.id));
      const { status, msg } = yield call(accountService.saveRole, {
        lang: locale,
        data: JSON.stringify({
          id: roleId,
          roleKey,
          name: roleName,
          nameEnus: roleName, //角色英文名称，暂定与中文名称一致
          menuIds: menuIds.join(';')
        })
      });
      const params = {
        operatorId: optId,
        actType:
          roleId === ''
            ? REPORT_ACTIVE_TYPE.ADD_ROLE
            : REPORT_ACTIVE_TYPE.MOD_ROLE,
        optResult: status,
        actContent: `${
          roleId === '' ? '新增' : '修改'
        }角色[${roleName}]操作成功`
      };
      if (status === 0) {
        yield put({ type: 'findAllRoles' });
        resolve && resolve();
      } else {
        params.actContent = `${
          roleId === '' ? '新增' : '修改'
        }角色[${roleName}]操作失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(accountService.recordActivityLog, params);
    },
    *addRoleUsers({ roleId, userIds, resolve, reject }, { put, select, call }) {
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { status, msg } = yield call(accountService.addRoleUsers, {
        roleId,
        userIds
      });
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.ADD_ROLE_USER,
        optResult: status,
        actContent: `角色[ID=${roleId}]添加用户[ID=${userIds}]操作成功`
      };
      if (status === 0) {
        yield put({ type: 'findRoleUsers', roleId });
        resolve && resolve();
      } else {
        params.actContent = `角色[ID=${roleId}]添加用户[ID=${userIds}]操作失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(accountService.recordActivityLog, params);
    },
    *deleteRoleUser(
      { roleId, userId, resolve, reject },
      { select, call, put }
    ) {
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { status, msg } = yield call(accountService.deleteRoleUser, {
        roleId,
        userId
      });
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_ROLE_USER,
        optResult: status,
        actContent: `角色[ID=${roleId}]删除用户[ID=${userId}]操作成功`
      };
      if (status === 0) {
        yield put({ type: 'findRoleUsers', roleId });
        resolve && resolve();
      } else {
        params.actContent = `角色[ID=${roleId}]删除用户[ID=${userId}]操作失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(accountService.recordActivityLog, params);
    },
    *delete({ roleId, resolve, reject }, { select, call, put }) {
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { status, msg } = yield call(accountService.deleteRole, roleId);
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_ROLE,
        optResult: status,
        actContent: `删除角色[ID=${roleId}]操作成功`
      };
      if (status === 0) {
        yield put({ type: 'findAllRoles' });
        resolve && resolve();
      } else {
        params.actContent = `删除角色[ID=${roleId}]操作失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(accountService.recordActivityLog, params);
    },
    *checkRoomAdmin({ userId, resolve, reject }, { call }) {
      const result = yield call(accountService.checkRoomAdmin, { userId });
      if (result.status == 0) {
        resolve && resolve(result.data);
      } else {
        reject && reject(msg);
      }
    }
  },

  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.roleManage) {
          dispatch({ type: 'findAllMenus' });
          dispatch({ type: 'findAllRoles' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/role.js